import { render, staticRenderFns } from "./ExamPurchaseConfirm.vue?vue&type=template&id=364cb8f6"
import script from "./ExamPurchaseConfirm.vue?vue&type=script&lang=js"
export * from "./ExamPurchaseConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports